import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import Title from "../components/Title";
import Searchbar from "../components/Searchbar";
import CategoryListStore from "../store/CategoryListStore";
import panelIcon from "../assets/PanelsIcon.png";
import installerIcon from "../assets/InstallersIcon.png";
import componentIcon from "../assets/ComponentsIcon.png";
import sellerIcon from "../assets/SellersIcon.png";
import materialIcon from "../assets/MaterialsIcon.png";
import equipmentIcon from "../assets/EquipmentsIcon.png";
import softwareIcon from "../assets/SoftwareIcon.png";
import LoadingStore from "../store/LoadingStore";
import { ClipLoader } from "react-spinners";

function Home() {
  const categoryList = CategoryListStore((state) => state.categoryList);
  const loading = LoadingStore((state) => state.loading);
  // console.log(categoryList)
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const images = [
    panelIcon,
    installerIcon,
    componentIcon,
    materialIcon,
    equipmentIcon,
    sellerIcon,
    softwareIcon,
  ];

  return (
    <div className="font-inter flex flex-col min-h-screen overflow-hidden">
      <Navbar />
      <div className="flex flex-col items-center w-full text-[#4E5562] px-4 sm:px-6 md:px-8 lg:px-8 xl:px-16 2xl:px-24">
        {/* Header */}
        <div className="flex justify-center items-center mt-[1vh]">
          <h3 className="text-base sm:text-lg md:text-lg 2xl:text-3xl text-center">
            World Solar Directory
          </h3>
        </div>

        {/* Title Section */}
        <div className="flex justify-center items-center my-4 lg:my-5">
          <Title title="Trusted by Millions" />
        </div>

        {/* Features */}
        <div className="flex flex-wrap justify-center items-center text-center mt-1 gap-3 md:gap-5 xl:gap-8">
          <div className="text-sm lg:text-base xl:text-base 2xl:text-lg">
            • Easy to use
          </div>
          <div className="text-sm lg:text-base xl:text-base 2xl:text-lg">
            • Global Solar Companies Database
          </div>
          <div className="text-sm lg:text-base xl:text-base 2xl:text-lg">
            • Verified Contacts
          </div>
        </div>

        {/* Searchbar */}
        <div className="flex justify-center items-center w-full max-w-screen-lg mt-10 lg:mt-14">
          <Searchbar />
        </div>
      </div>

      {/* Main Content */}
      <div className="flex flex-1 flex-col justify-center items-center w-full text-[#4E5562] px-4 sm:px-6 md:px-8">
        {/* Grid Section */}
        <div className="mt-[5vh] w-full">
          <div className="container mx-auto px-4 sm:px-6 md:px-6 lg:px-8 xl:px-16 2xl:px-24">
            <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 xl:grid-cols-7 gap-4 sm:gap-6 xl:gap-8 2xl:gap-12 text-center text-[#9CA3AF]">
              {Object.entries(categoryList).map(([category, value], index) => (
                <div
                  key={category}
                  className="flex flex-col items-center items-stretch"
                >
                  <div className="flex-grow flex items-end justify-center">
                    <img
                      src={images[index]}
                      alt="icon"
                      className="pb-2 max-h-[80px] object-contain"
                    />
                  </div>
                  <div className="flex flex-col">
                    <p className="text-sm xl:text-base 2xl:text-lg break-words">
                      {capitalizeFirstLetter(category)}
                    </p>
                    {loading ? ( <div className="flex justify-center w-full">
                      <ClipLoader
                        color="#006b4f"
                        size={15}
                        speedMultiplier={1}
                      /></div>
                    ) : (
                      <p className="text-sm 2xl:text-base">{value}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Home;